import Button from '../components/Button'
import { LogoMark } from '../components/Logo'
import { nav } from '../data/site'
import { useSeo } from '../lib/seo'

export default function NotFound() {
  useSeo({
    title: 'Seite nicht gefunden',
    description:
      'Diese Seite existiert nicht oder wurde verschoben. Hier finden Sie zurück zur Startseite der CASA Hausverwaltung.',
    path: '/404',
    noIndex: true,
  })

  return (
    <section className="page-hero on-dark" style={{ paddingBottom: 0 }}>
      <div className="blueprint" aria-hidden="true" />
      <div className="container">
        <div className="notfound">
          <div>
            <LogoMark
              size={56}
              style={{ marginInline: 'auto', color: 'var(--gold)' }}
            />
            <p className="notfound__code">404</p>
            <h1 style={{ color: 'var(--on-dark)' }}>Seite nicht gefunden</h1>
            <p
              style={{
                marginTop: 'var(--s-4)',
                maxWidth: '34rem',
                marginInline: 'auto',
                color: 'var(--on-dark-body)',
              }}
            >
              Diese Adresse führt ins Leere - vielleicht wurde die Seite
              verschoben. Über die Navigation finden Sie zurück.
            </p>

            <div className="notfound__links">
              <Button to="/" icon="arrowRight">
                Zur Startseite
              </Button>
              {nav.slice(0, 3).map((item) => (
                <Button key={item.to} to={item.to} variant="ghost-dark">
                  {item.label}
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
